export default "__VITE_ASSET__04l0VubP__"